import React from "react";
import FlexBox from "view/components/Layout/FlexBox";
import emptySearchImage from "assets/EmptySearchIcon/img.png";
import {Typography} from "@material-ui/core";
import clsx from "clsx";
import useStyles from "./styles";

const EmptyResultsView = ({
  searchQuery,
  shouldShift = false,
}: {
  searchQuery: string;
  shouldShift?: boolean;
}) => {
  const classes = useStyles();

  return (
    <FlexBox
      alignCenter
      justifyCenter
      fullWidth
      className={clsx(
        classes.noResultBlock,
        shouldShift && classes.shiftedBlock
      )}
    >
      <FlexBox column gap={3} alignCenter justifyCenter>
        <img
          src={emptySearchImage}
          alt="No results"
          className={classes.noResultImg}
        />
        <Typography className={classes.noResultMessage}>
          No results found for ”{searchQuery}”
        </Typography>
      </FlexBox>
    </FlexBox>
  );
};

export default EmptyResultsView;
